import Input, { type InputProps } from '2-core-elements/FormElements/Input';
import { type FC, useId, useMemo } from 'react';
import { getActiveFilterSingleValue, getUpdatedFilters } from './ListingFilterHelpers';
import { type ActiveFilter } from './ListingFiltersTypes';

interface ListingFilterInputProps {
    placeholder: string;
    field: string;
    label?: string;
    activeFilters: ActiveFilter[]; // current filter that is active (selected)
    setActiveFilters: (newFilters: ActiveFilter[]) => void; // function to update active filters
    disabled?: boolean;
    skin?: InputProps['skin'];
    suffixIcon?: InputProps['suffixIcon'];
    prefixIcon?: InputProps['suffixIcon'];
    onSuffixIconClick?: InputProps['onSuffixIconClick'];
    onPrefixIconClick?: InputProps['onPrefixIconClick'];
    maxLength?: InputProps['maxLength'];
}

const ListingFilterInput: FC<ListingFilterInputProps> = ({
    placeholder,
    field,
    activeFilters,
    setActiveFilters,
    disabled,
    skin,
    onSuffixIconClick,
    onPrefixIconClick,
    suffixIcon,
    prefixIcon,
    maxLength,
    label,
}) => {
    const baseId = useId();
    const id = `${baseId}-${field}`;

    const inputValue = useMemo(() => {
        return getActiveFilterSingleValue(activeFilters, field);
    }, [activeFilters, field]);

    return (
        <div className="listing-app-filter-item">
            {label && <label htmlFor={id} className="listing-app-filter-label">{label}</label>}
            <Input
                id={id}
                debounceTimeout={300}
                placeholder={placeholder}
                suffixIcon={suffixIcon}
                prefixIcon={prefixIcon}
                disabled={disabled}
                ariaLabel={label ? undefined : placeholder}
                onChange={({ target: { value } }): void => {
                    // update the 'search' field with the new value
                    setActiveFilters(
                        getUpdatedFilters(
                            activeFilters,
                            field,
                            value ? [value] : []
                        )
                    );
                }}
                value={inputValue}
                skin={skin}
                onSuffixIconClick={onSuffixIconClick}
                onPrefixIconClick={onPrefixIconClick}
                maxLength={maxLength}
            />
        </div>
    );
};

export default ListingFilterInput;
